// extracted by mini-css-extract-plugin
module.exports = {"description":"complete_description_WFD_b","mainHeader":"complete_mainHeader_2IA3I","welcomeButton":"complete_welcomeButton_33CXM"};